import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const PRESENCE_INTERVAL_MS = 60_000;

export default function AnalyticsTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;

    supabase
      .from("page_view_events")
      .insert({ user_id: user.id, path: location.pathname })
      .then(() => {});
  }, [user, location.pathname]);

  useEffect(() => {
    if (!user) return;

    const ping = async () => {
      const { error } = await supabase
        .from("user_presence")
        .upsert(
          { user_id: user.id, last_seen: new Date().toISOString() },
          { onConflict: "user_id" }
        );

      if (error?.code === "23503") {
        // Some legacy accounts don't have a profiles row yet.
        await supabase
          .from("profiles")
          .upsert({ user_id: user.id }, { onConflict: "user_id" });

        await supabase
          .from("user_presence")
          .upsert(
            { user_id: user.id, last_seen: new Date().toISOString() },
            { onConflict: "user_id" }
          );
      }
    };

    ping();
    const interval = window.setInterval(ping, PRESENCE_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") ping();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [user]);

  return null;
}

